import React, { type ButtonHTMLAttributes } from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import './LoadingButton.css';

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'small' | 'medium' | 'large';
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  loadingText,
  variant = 'primary',
  size = 'medium',
  children,
  disabled,
  className = '',
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      {...props}
      disabled={isDisabled}
      className={`loading-button loading-button--${variant} loading-button--${size} ${className} ${
        loading ? 'loading-button--loading' : ''
      }`}
    >
      {loading && (
        <LoadingSpinner
          size={size === 'large' ? 'medium' : 'small'}
          color={variant === 'primary' ? 'white' : 'primary'}
          className="loading-button__spinner"
        />
      )}
      <span className={loading ? 'loading-button__text--loading' : ''}>
        {loading && loadingText ? loadingText : children}
      </span>
    </button>
  );
};
